export default __webpack_public_path__ + "static/media/4.d7957f0b.jpeg";